import React from 'react'

const PageNotFound = () => {
  return (
    <div className="bg-black h-screen flex items-center justify-center ">
    <div className="container mx-auto p-4">
      <div className="bg-gray-700 max-w-md mx-auto p-8 rounded-lg shadow-lg">
        <h2 className="text-3xl text-white font-bold text-center mb-4">404 - Page Not Found</h2>
        <p className="text-lg text-gray-200 text-center">
          Oops! The page you are looking for does not exist.
        </p>
      </div>
    </div>
  </div>
  )
}

export default PageNotFound